// Issue #1021, checklist punto 6
// (apps/api/docs/entitlement-l3-contratto-client.md) — l'OR "nudo" a tre
// soggetti usato dal BE per gate come BridgesService.assertL3SummaryModuleAccess
// (GET bridges/:id/overview/L3, ora 403 se nessuno dei tre ha il modulo).
// NON coincide con l3Access.canEdit (sul DTO di ponte è a due soggetti, "posso
// creare") né con l3Access.canView (segue L3_EXPIRED_MODULE_POLICY, oggi
// sempre true) — va ricalcolato qui dai tre flag grezzi, mai riletto da
// canEdit/canView.
export const hasL3ModuleAccess = l3Access =>
  !!(
    l3Access?.ownerHasL3Module ||
    l3Access?.userHasL3Module ||
    l3Access?.inspectionOwnerHasL3Module
  );
